import { render, staticRenderFns } from "./ArchiveChatContent.vue?vue&type=template&id=1ca9811d&scoped=true&"
import script from "./ArchiveChatContent.vue?vue&type=script&lang=js&"
export * from "./ArchiveChatContent.vue?vue&type=script&lang=js&"
import style0 from "./ArchiveChatContent.vue?vue&type=style&index=0&id=1ca9811d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca9811d",
  null
  
)

export default component.exports